module.exports = __webpack_public_path__ + "img/_.79c0a23d.svg";